import { createContext } from 'react';
import EditPermissionContext from 'types/contexts/EditPermissionContext';

export default createContext({} as EditPermissionContext);
